import type { Database } from '$lib/types/supabase';

export const CONTRACT_NAME = {
	market_minting_policy: 'market_minting_policy',
	market_validator: 'market_validator',
	public_auction_validator: 'public_auction_validator',
	public_auction_state_token: 'public_auction_state_token',
	private_auction_validator: 'private_auction_validator',
	private_auction_state_token: 'private_auction_state_token',
	auction_finset_validator: 'auction_finset_validator',
	auction_finset_separator: 'auction_finset_separator',
	auction_finset_script: 'auction_finset_script',
	bulk_minting_policy: 'bulk_minting_policy',
	ownership_mint_cbor: 'ownership_mint_cbor',
	metadata_control_evolve_cbor: 'metadata_control_evolve_cbor',
	onchain_nft_cbor: 'onchain_nft_cbor'
} as const;

export type ContractName = keyof typeof CONTRACT_NAME;
export type ContractCborHex = string;
export type CardanoContracts = {
	[x in ContractName]: ContractCborHex;
};

export const SCRIPT_REFERENCE_NAME = {
	public_auction_currency_symbol: 'public_auction_currency_symbol',
	private_auction_currency_symbol: 'private_auction_currency_symbol'
};

export type ScriptReferenceName = keyof typeof SCRIPT_REFERENCE_NAME;
export type ScriptReferenceHash = string;
export type CardanoScriptReferences = {
	[x in ScriptReferenceName]: ScriptReferenceHash;
};

export function isCardanoScriptReferences(
	scripts: Record<string, string>
): scripts is CardanoScriptReferences {
	const fields = Object.keys(SCRIPT_REFERENCE_NAME);
	for (const field of fields) {
		if (!scripts[field]) {
			return false;
		}
	}
	return true;
}

export function isCardanoContracts(
	contracts: Record<string, string>
): contracts is CardanoContracts {
	const fields = Object.keys(CONTRACT_NAME);
	for (const field of fields) {
		if (!contracts[field]) {
			return false;
		}
	}
	return true;
}

export type Market = Database['public']['Tables']['market']['Row'] & {
	contracts: CardanoContracts;
	scriptReferences: CardanoScriptReferences;
};

export type MarketId = string; // uuid
export type MarketLookup = Record<MarketId, Market>;

export function createMarketLookup(markets: Market[]): MarketLookup {
	const lookup: MarketLookup = {};
	markets.forEach((market) => (lookup[market.id] = market));

	return lookup;
}
